import * as Y from "yjs";
import {yCursorPlugin, ySyncPlugin, ySyncPluginKey, yUndoPlugin} from "y-prosemirror";
import {buildRemoteCaretElement} from "../../helpers/utils";

function buildUndoManagerTypes({yXmlFragment, yReferenceMarks, yComments}) {
    const undoManagerTypes = [yXmlFragment];
    if (yReferenceMarks) undoManagerTypes.push(yReferenceMarks);
    if (yComments) undoManagerTypes.push(yComments);
    return undoManagerTypes;
}

export function createCollaborationPluginBundle({
    collaborationEnabled,
    yXmlFragment,
    awareness,
    yReferenceMarks,
    yComments,
}) {
    if (!collaborationEnabled || !yXmlFragment || !awareness) {
        return [];
    }

    const undoManagerTypes = buildUndoManagerTypes({
        yXmlFragment,
        yReferenceMarks,
        yComments,
    });

    return [
        ySyncPlugin(yXmlFragment),
        yCursorPlugin(awareness, {cursorBuilder: buildRemoteCaretElement}),
        yUndoPlugin({
            undoManager: new Y.UndoManager(undoManagerTypes, {
                trackedOrigins: new Set([ySyncPluginKey, null]),
            }),
        }),
    ];
}

